import { SimpleRevisionTypeEnums } from '../shared/generated';
export var CommonUploadFileAcceptTypeList = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 'image/tiff', 'image/bmp', 'image/gif'];
export var JoveUploadFileTypeMap = function JoveUploadFileTypeMap() {
  return {
    file: {
      value: SimpleRevisionTypeEnums.DOC_FILE,
      label: 'File'
    },
    customUrl: {
      value: SimpleRevisionTypeEnums.FILE_URL,
      label: 'Custom URL'
    }
  };
};
export var JoveUploadFileTypeList = function JoveUploadFileTypeList() {
  return Object.values(JoveUploadFileTypeMap());
};